import { Page, Stripe } from '@/types'

type RequestOptions = {
  method?: string
  body?: string
  headers?: Record<string, string>
}

async function request(
  url: string,
  data?: Record<string, unknown>,
  options?: RequestOptions
) {
  const params = {
    method: 'GET',
    ...options
  }

  let query = ''
  if (data && params.method.toUpperCase() === 'GET') {
    const stringifiedData = Object.keys(data).reduce(
      (acc: Record<string, string>, i) => ({ ...acc, [i]: String(data[i]) }),
      {}
    )
    query = '?' + new URLSearchParams(stringifiedData)
  } else if (data) {
    params.body = JSON.stringify(data)
  }

  try {
    const baseUrl = window.location.protocol + '//' + window.location.host
    const response = await fetch(`${baseUrl}/api/${url}${query}`, params)
    return await response.text()
  } catch (e) {
    throw new Error(`API request failed: ${e}`)
  }
}

function getPageHTML(page: Page) {
  return request('html/page', page, { method: 'POST' })
}

function getStripeHTML(stripes: Stripe[]) {
  return request('html/stripes', { stripes }, { method: 'POST' })
}

export default {
  getPageHTML,
  getStripeHTML
}
